import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Role } from '../types/user';
import { Plant } from '../types/plant';
import { Profile } from '../types/profile';
import { Zone } from '../types/zones';
import { User } from '../types';

interface AppState {
  roles: Role[];
  plants: Plant[];
  zones: Zone[];
  dashboardUsers: User[];
  hosts: User[];
  arManagers: User[];
  profile: Profile;
    user: User | null;
  setRoles: (users: Role[]) => void;
  setPlants: (plants: Plant[]) => void;
  setZones: (zones: Zone[]) => void;
  setDashboardUsers: (dashboardUsers: User[]) => void;
  setHosts: (hosts: User[]) => void;
  setArManagers: (arManagers: User[]) => void;
  setProfile: (plants: Profile) => void;
  setUser: (user: User | null) => void;   // ✅ ADD THIS
  clearData: () => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      roles: [],
      plants: [],
      zones: [],
      dashboardUsers: [],
      hosts: [],
      arManagers: [],
      profile: {} as Profile,
            user: null,   // ✅ INITIAL VALUE

      setRoles: (roles) => set({ roles }),
      setPlants: (plants) => set({ plants }),
      setZones: (zones) => set({ zones }),
      setDashboardUsers: (dashboardUsers) => set({ dashboardUsers }),
      setHosts: (hosts) => set({ hosts }),
      setArManagers: (arManagers) => set({ arManagers }),
      setProfile: (profile) => set({ profile }),
      setUser: (user) => set({ user }),   // ✅ SETTER ADDED
      clearData: () => set({ roles: [], plants: [], zones: [], profile: {} as Profile,user: null }),
    }),
    {
      name: 'app-storage',
    }
  )
);
